import React from 'react';
import {useTable, useRowSelect, usePagination} from 'react-table';
import {useSticky} from 'react-table-sticky';
import '../StocksFBSTable/Tablestyles.scss';

export interface ITableRowDelivery {
    date?: string,
    status?: string,
    warehouse?: string,
    filterWarehouse?: string,
    count?: string,
    numberDocument?: string,
    dataDocument?: string,
    responsible?: string,
    comment?: string,
    documents?: string,
}

interface ITableDeliveryProps {
    data: ITableRowDelivery[],
}

const Table: React.FC<ITableDeliveryProps> = ({
    data,
}) => {

    const columns = React.useMemo(
        () => [
            { Header: '#', accessor: 'id', sticky: "left",minWidth: 34, width: 34, maxWidth: 34},
            { Header: 'Дата создания', accessor: 'date', minWidth: 180, width: 180, maxWidth: 180},
            { Header: 'Статус', accessor: 'status',},
            { Header: 'Склад', accessor: 'warehouse', },
            { Header: 'Фильтр товаров', accessor: 'filterWarehouse',},
            { Header: 'Кол-во', accessor: 'count',},
            { Header: 'Номер документа', accessor: 'numberDocument',},
            { Header: 'Дата документа', accessor: 'dataDocument', minWidth: 180, width: 180, maxWidth: 180},
            { Header: 'Ответственный', accessor: 'responsible', },
            { Header: 'Комментарий', accessor: 'comment', },
            { Header: 'Документы', accessor: 'documents', },
        ],
        [],
    )


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data,
    } as any,
        useSticky,
        useRowSelect,
    );

    return (
            <div className="w-full overflow-hidden">
                <div className="overflow-auto rounded-sm">
                    <table {...getTableProps()} className="react-table sticky">
                        <thead className="header">
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => {
                                    return(
                                        <th {
                                                ...column.getHeaderProps(
                                                    {
                                                        style: { minWidth: column.minWidth, width: column.width, maxWidth: column.maxWidth },
                                                    })
                                            }>{column.render('Header')}</th>
                                    )
                                })}
                            </tr>
                        ))}
                        </thead>
                        <tbody {...getTableBodyProps()} className="body">
                        {rows.map((row) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map(cell => {
                                        return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                    })}
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

export default Table;
